import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Card,
	CardContent,
	Typography,
	Button,
	Chip,
} from '@material-ui/core';
import {
	CloseOutlined as CloseIcon,
	NavigateBeforeOutlined as BackIcon,
} from '@material-ui/icons';
import {
	MyPATDialog,
	MyPATIconButton,
	MyPATTextField,
	MyPATTextArea,
} from '../../common';

import WithContent from '../../mylibrary/containers/WithContent';
import miniLibraryServices from '../services/miniLibraryServices';
import { miniLibraryList, getMiniLibraryCount, showMsg } from '../actions/miniLibrariesActions';
import { MiniLibraryBody } from '../types/MiniLibraryBody';
import ContentTypeData from '../../mylibrary/types/ContentTypeData';
import ContentSubtypeData from '../../mylibrary/types/ContentSubtypeData';
import ACLService from '../../acl/services/aclService';


const styles = (theme: Theme) => createStyles({
	mb1x: {
		marginBottom: theme.spacing.unit,
	},
	ml1x: {
		marginLeft: theme.spacing.unit,
	},
	mb2x: {
		marginBottom: theme.spacing.unit * 2,
	},
	fwNormal: {
		fontWeight: theme.typography.fontWeightRegular,
	},
	cardContentRoot: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
		'&:last-child': {
			paddingBottom: theme.spacing.unit * 2,
		},
	},
	textRight: {
		textAlign: 'right',
	},
	cursorPointer: {
		cursor: 'pointer',
	},

	buttonOval: {
		borderRadius: theme.spacing.unit * 2,
	},

	backIconRoot: {
		fill: theme.palette.text.secondary,
		fontSize: 24,
		opacity: 0.5,
		marginBottom: 3
	},

	detailsContainer: {
		padding: `${theme.spacing.unit * 2}px 0`,
		marginBottom: theme.spacing.unit * 2,
		borderBottom: `1px solid ${theme.palette.grey[300]}`,
		position: 'relative',
		'&:after': {
			content: '"and"',
			fontFamily: theme.typography.fontFamily,
			position: 'absolute',
			bottom: 0,
			fontSize: theme.typography.fontSize,
			padding: `0 ${theme.spacing.unit * 1.5}px`,
			left: '50%',
			transform: 'translateX(-50%) translateY(50%)',
			display: 'inline-block',
			backgroundColor: theme.palette.common.white,
		},
		'&:last-child': {
			borderBottom: 0,
			'&:after': {
				display: 'none',
			}
		},
		

	},
	breadcrumbList: {
		padding: 0,
		margin: 0,
		'& > li': {
			...theme.typography.body1,
			display: 'inline-block',
			color: theme.palette.text.primary,
			'&:after': {
				content: '">"',
				margin: `0 ${theme.spacing.unit}px`,
			},
			'&:last-child:after': {
				display: 'none',
			}
		}
	},
	chipsBox: {
		'& > div': {
			marginLeft: theme.spacing.unit,
			height: theme.spacing.unit * 3.5,
			'& > span': {
				fontSize: '0.7rem',
				paddingLeft: theme.spacing.unit * 2,
			},
		}
	},
	waitingText:{
		fontSize: "30px",
		padding: "19px",
	},
	deleteChip:{
		color: '#3698fb',
		position: 'absolute',
		right: '1%'
	
	}
});

interface AddMiniLibraryDialogProps extends WithStyles<typeof styles> {
	dialogOpen: boolean,
	dialogData: string,
	dialogCloseHandler: () => void,
	getMiniLibraryCount: () => void,
	miniLibraryList: () => void,
	miniLibrary: {
		list: MiniLibraryBody[],
		count: number,
	},
	contentTypes: ContentTypeData[],
	contentSubtypes: ContentSubtypeData[],
	showMsg: (msg: string, errorType: string) => void
}

interface AddMiniLibraryDialogState {
	addContentDialogOpen: boolean,
	tempSelectedContent: string[],
	selectedContent: any,
	formData: {
		name: string,
		description: string,
		contentMapped: {
			audios: any[],
			formulas: any[],
			question: any[],
			studymaterial: any[],
			testpapers: any[],
			videos: any[],
		},
	
	},
	selectAll: Boolean,
	totalCount: any,
	filterContent: any,
	errors: any,
	waitingDialogOpen: Boolean,
	isAllPages:Boolean
}

const defaultFormData = {
	name: '',
	description: '',
	contentMapped: {
		audios: [],
		formulas: [],
		question: [],
		studymaterial: [],
		testpapers: [],
		videos: [],
	}
}

class AddMiniLibraryDialog extends Component<AddMiniLibraryDialogProps, AddMiniLibraryDialogState> {
	constructor(props: AddMiniLibraryDialogProps) {
		super(props);
		this.state = {
			addContentDialogOpen: false,
			formData: defaultFormData,
			tempSelectedContent: [],
			selectedContent: [],
			selectAll: false,
			totalCount: "",
			filterContent:"",
			isAllPages:false,
			waitingDialogOpen: false,
			errors: {
				name: '',
			}
		};

		this.handleDialogSave = this.handleDialogSave.bind(this);
		this.handleAddContentDialogOpen = this.handleAddContentDialogOpen.bind(this);
		this.handleAddContentDialogClose = this.handleAddContentDialogClose.bind(this);
		this.handleAddContentClick = this.handleAddContentClick.bind(this);
	}

	componentWillReceiveProps() {
		setTimeout(this.populateForEdit.bind(this), 600);
	}

	componentWillUnmount() {
		this.resetForm();
	}

	// populate form data for edit
	populateForEdit = () => {
		if (!_.isEmpty(this.props.dialogData)) {
			let { name, description, contentMapped }: any = _.find(this.props.miniLibrary.list, ['_id', this.props.dialogData]);
			const selectedContent = this.convertFromLibrary(contentMapped);
			contentMapped = this.convertToLibraryIdWithNew(selectedContent);

			this.setState({
				formData: {
					name,
					description,
					contentMapped
				},
				selectedContent,
				tempSelectedContent: selectedContent
			})
		}
	}

	// generate preview data for categorized content
	generateBreadCrumbs() {
		let formattedContent: any = {};
		let { selectedContent } = this.state;
		selectedContent = _.groupBy(selectedContent, "contentTypeCode");

		const getTypeCodeName = (code: any) => _.get(_.find(this.props.contentTypes, ['code', code]), 'name', '');
		const getSubTypeCodeName = (code: any) => _.get(_.find(this.props.contentSubtypes, ['code', code]), 'name', '');
		for (let type in selectedContent) {
			selectedContent[type].map((t: any) => {

				t.subjects && t.subjects.map((sD: any, sI: number) => {

					if (_.isEmpty(_.get(sD, 'subSubjects', []))) {
						return;
					}

					sD.subSubjects.map((ssD: any, ssI: number) => {
						ssD.chapters.map((chD: any, chI: number) => {
							chD.concepts.map((coD: any, coI: number) => {
								let key = `${sD.subjectId.name}-${sD.subjectId._id}`;

								if (ssD.subSubjectId) {
									key += `|${coD.classId.name}-${coD.classId._id}|${ssD.subSubjectId.name}-${ssD.subSubjectId._id}`;
								}
								if (!formattedContent[key]) {
									formattedContent[key] = [];
								}
								let data: any = {
									contentType: [],
									count: 0,
									contentTypeCode: [],
								};
								if(formattedContent[key]['contentType'] && formattedContent[key]['contentType'].length>0){
									data.contentType = formattedContent[key]['contentType'];
								}
								if(formattedContent[key]['contentTypeCode'] && formattedContent[key]['contentTypeCode'].length>0){
									data.contentTypeCode = formattedContent[key]['contentTypeCode'];
								}
								if (type !== 'question') {
									if(!data.contentType.includes(getTypeCodeName(t.contentTypeCode)))
									data.contentType.push(getTypeCodeName(t.contentTypeCode));
									data.contentTypeCode.push(t.contentTypeCode);

									data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
								} else {
									if(!data.contentType.includes(getSubTypeCodeName(t.contentSubTypeCode)))
									data.contentType.push(getSubTypeCodeName(t.contentSubTypeCode));
									data.contentTypeCode.push(t.contentTypeCode);
									data.count = formattedContent[key]['count'] ? formattedContent[key]['count'] + 1 : 1;
								}
								formattedContent[key] = data;
							})
						})
					})
				})
			})
		}
		return formattedContent;
	}
	// reset for data and error messages
	resetForm = () => this.setState({
		formData: defaultFormData,
		errors: {
			name: '',
		}
	});

	// convert mapped content from groupby to array
	convertFromLibrary = (contentMapped: any) => {
		let selectedContent: any = [];

		for (let val in contentMapped) {
			selectedContent.push(...contentMapped[val]);
		}

		selectedContent = selectedContent.filter((s: any) => { return s != null; })
		return selectedContent;
	}

	// convert selected content from array to groupby with existing data from state
	convertToLibraryId = (selectedContent: any) => {
		const groupByType: any = _.groupBy(selectedContent, "contentTypeCode");
		let { contentMapped }: any = this.state.formData;

		for (let key in groupByType) {
			const keyVal = groupByType[key];
			let tempArr: any = [];
			_.map(keyVal, data => {
				tempArr.push(data.content_Id);
			});
			contentMapped[key] = tempArr;
		}
		return contentMapped;
	}

	// convert selected content from array to groupby
	convertToLibraryIdWithNew = (selectedContent: any) => {
		let groupByType: any = _.groupBy(selectedContent, "contentTypeCode");
		let cM: any = {};

		for (let key in groupByType) {
			const keyVal = groupByType[key];
			let tempArr: any = [];
			_.map(keyVal, data => {
				tempArr.push(data.content_Id);
			});
			cM[key] = tempArr;
		}
		return cM;
	}

	// handle add content dialog open and close
	handleAddContentDialogOpen = () => {
		// if (ACLService.hasAccessTo(['CONTENT'], ['VIEW'])) {
		// 	this.setState({ addContentDialogOpen: true })
		// }
		// else {
		// 	this.props.showMsg(`You don't have access to Content View`, 'error');
		// }
	};
	handleAddContentDialogClose = () => this.setState({ addContentDialogOpen: false });

	// handle form input change for name and description
	handleInputChange = (evt: any) => {
		let formData: any = this.state.formData;
		formData[evt.target.name] = evt.target.value;
		this.setState({ formData: { ...this.state.formData, ...formData } });
	}

	// on add click store selected content from temp to selected
	handleAddContentClick = () => {
		const { tempSelectedContent,selectedContent,formData,selectAll, totalCount, filterContent } = this.state;

		if(selectAll ){
			
			if(totalCount != 0 ){
			}
		}
		else{
			const contentMapped = this.convertToLibraryId(tempSelectedContent);
			this.setState({
				selectedContent: tempSelectedContent,
				formData: {
					...this.state.formData,
					contentMapped,
				}
			});
	
		}
		this.handleAddContentDialogClose();
	}

	// handle and store selected content temporary basis
	handleContentSelect = (selectedContent: any) => {
		this.setState({ tempSelectedContent: selectedContent,totalCount:selectedContent.length })
	};

	//select all 

	handleSelectAll= (selectAll:any,totalCount:any,filterContent:any,isAllPages:any,selectedContent:any) => {
		if(selectAll){
			if(!isAllPages){
				this.setState({
					totalCount: selectedContent.length,
					tempSelectedContent: selectedContent,
				})
			}else{
				this.setState({
					selectAll,
					totalCount,
					filterContent,
					isAllPages
				})
			}
			
		}
		else{
			this.setState({
				selectAll,
				totalCount:0,
				tempSelectedContent:[],
				isAllPages
			})
		}
	}

	// handle mini library add and edit
	handleDialogSave = () => {
		const { name, description, contentMapped } = this.state.formData;
		const { selectAll, filterContent } = this.state;
		if (_.isEmpty(name)) {
			return this.setState({ errors: { name: 'Name is required' } });
		}
		const postData: any = {
			name,
			description,
			contentMapped,
			selectAll: false,
		};

		if(selectAll){
			delete postData['contentMapped']
			postData['filterContent'] = filterContent;
			postData['selectAll'] = true;
			this.setState({
				selectAll: false, 
				totalCount: 0, 
				// waitingDialogOpen: true
			})
		}
		

		if(_.isEmpty(this.props.dialogData)){
			miniLibraryServices.create(postData).then(res => {
				// this.setState({waitingDialogOpen: false})
				this.props.miniLibraryList();
				this.props.getMiniLibraryCount();
				this.props.dialogCloseHandler();
			})

		}
		else{
			miniLibraryServices.update(postData, this.props.dialogData).then(res => {
				// this.setState({waitingDialogOpen: false})
				this.props.miniLibraryList();
				this.props.dialogCloseHandler();
			});
		}
	}

	// handle mini library delete
	handleDialogDelete = () => {
		miniLibraryServices.remove(this.props.dialogData, this.state.formData.name).then(res => {
			this.props.miniLibraryList();
			this.props.getMiniLibraryCount();
			this.props.dialogCloseHandler();
		});
	}

	// handle validation for library name field
	handleInputBlur = (evt: any) => {
		if (_.isEqual(evt.target.name, 'name')) {
			if (_.isEmpty(evt.target.value)) {
				let { errors }: any = this.state;
				errors.name = 'Name is required';
				return this.setState({ errors });
			} else {
				return this.setState({ errors: { name: '' } });
			}
		}
	}

	// remove content based on its type and class-subject-subsubject combination
	removeContent(deleteContenetType: string, deleteKey: string, e: any) {
		let { selectedContent, formData }: any = this.state;
		selectedContent = _.groupBy(selectedContent, "contentTypeCode");
		for (let type in selectedContent) {
			selectedContent[type].map((t: any, i: number) => {
				t.subjects && t.subjects.map((sD: any, sI: number) => {
					sD.subSubjects.map((ssD: any, ssI: number) => {
						ssD.chapters.map((chD: any, chI: number) => {
							chD.concepts.map((coD: any, coI: number) => {
								let key = `${sD.subjectId.name}-${sD.subjectId._id}`;
								if (ssD.subSubjectId) {
									key += `|${coD.classId.name}-${coD.classId._id}|${ssD.subSubjectId.name}-${ssD.subSubjectId._id}`;
								}
								//When outside delete is clicked
								if(deleteContenetType == "true" && _.isEqual(key, deleteKey)){
									delete selectedContent[type][i];
								}
								if (type !== 'question') {
									if (_.isEqual(key, deleteKey) && _.isEqual(type, deleteContenetType)) {
										delete selectedContent[type][i];
									}
								} else {
									if (_.isEqual(key, deleteKey) && _.isEqual(type, deleteContenetType)) {
										delete selectedContent[type][i];
									}
								}
							})
						})
					})
				})
			})
		}
		selectedContent = this.convertFromLibrary(selectedContent);
		let contentMapped = this.convertToLibraryIdWithNew(selectedContent);
		this.setState({
			selectedContent,
			formData: {
				...this.state.formData,
				contentMapped,
			}
		});

	}

	render() {
		const {
			classes,
			dialogOpen,
			dialogCloseHandler,
			dialogData,
		} = this.props;

		const {
			addContentDialogOpen,
			selectedContent,
			tempSelectedContent,
			errors,
			selectAll,
			totalCount,
			waitingDialogOpen
		} = this.state;

		const { name, description } = this.state.formData;

		const otherDialogProps = {
			fullWidth: true,
			maxWidth: 'md',
			scroll: 'body',
		};

		const detailsData = this.generateBreadCrumbs();

		// generate content preview breadcrumb
		const generateBreadcrumb = (key: string) => {
			const classSubjectSubSubject = key.split('|');
			let breadcrumb: any = '';
			if (classSubjectSubSubject.length > 1) {
				const subject = classSubjectSubSubject[0].split('-');
				const clas = classSubjectSubSubject[1].split('-');
				const subSubject = classSubjectSubSubject[2].split('-');
				breadcrumb = (
					<>
						<li>Class {clas[0]}</li>
						<li>{subject[0]}</li>
						<li>{subSubject[0]}</li>
					</>
				)
			}
			return breadcrumb;
		}

		// render preview content
		const renderContent = () => {
			let data: any = [];
			for (let key in detailsData) {
				data.push(
					<Grid
						key={key}
						container spacing={8} className={classes.detailsContainer}
					>
							<Button 
						className={classes.deleteChip}
						onClick={this.removeContent.bind(this, "true", key)}
						>Delete</Button>
						<Grid item xs={12}>
							<Typography variant="body1" color="textSecondary">{detailsData[key].count} Selected Content Items In:</Typography>
						</Grid>
						<Grid item xs={12} className={classes.mb1x}>
							<ul className={classes.breadcrumbList}>
								{generateBreadcrumb(key)}
							</ul>
						</Grid>
						<Grid item xs={12} className={classes.chipsBox}>
							{_.map(detailsData[key].contentType, (type: string, i: number) => (
								<Chip key={`chip-${type}-${i}`} onDelete={this.removeContent.bind(this, detailsData[key].contentTypeCode[i], key)} label={type} />
							))}
						</Grid>
					</Grid>
				)
			}
			return data;
		}

		return (
			<>	
				<MyPATDialog 
					dialogOpen={waitingDialogOpen}>
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								<Typography variant="h3" className = {classes.waitingText}>Your Mini Library is getting ready.</Typography>
							</Grid>
						</Grid>
				</MyPATDialog>
				<MyPATDialog
					dialogOpen={dialogOpen}
					otherDialogProps={otherDialogProps}
					onDialogSave={this.handleDialogSave.bind(this)}
					onDialogDelete={ACLService.hasAccessTo(['USER'], ['DELETE']) && !_.isEmpty(dialogData) ? this.handleDialogDelete.bind(this) : undefined}
					customDialogTitle={
						<Grid container justify="space-between" alignItems="center">
							<Grid item xs>
								{_.isEmpty(dialogData)
									? <Typography variant="h6"> Add Mini Library </Typography>
									: <Typography variant="h6"> Update Mini Library </Typography>
								}
							</Grid>

							<Grid item xs="auto" className={classes.textRight}>
								<MyPATIconButton buttonVariant="flat" onClick={dialogCloseHandler}>
									<CloseIcon />
								</MyPATIconButton>
							</Grid>
						</Grid>
					}
				>
					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Grid container alignItems="center">
								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="h6" className={classes.fwNormal}>Basic Info</Typography>
								</Grid>

								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="body1" gutterBottom>Library Name</Typography>
									<MyPATTextField
										inputId="name"
										name="name"
										placeholder="Enter User Name"
										value={name}
										onChange={this.handleInputChange.bind(this)}
										fullWidthControl
										onBlur={this.handleInputBlur.bind(this)}
										error={!_.isEmpty(errors.name)}
										errorText={!_.isEmpty(errors.name) ? errors.name : ''}
									/>
								</Grid>

								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="body1" gutterBottom>Descriptions</Typography>
									<MyPATTextArea
										inputId="description"
										name="description"
										placeholder="Write here..."
										rows="3"
										value={description}
										onChange={this.handleInputChange.bind(this)}
										multiline
										fullWidthControl
									/>
								</Grid>
							</Grid>
						</CardContent>
					</Card>

					<Card className={classes.mb1x}>
						<CardContent className={classes.cardContentRoot}>
							<Grid container alignItems="center">
								<Grid item xs={12} className={classes.mb1x}>
									<Typography variant="h6" className={classes.fwNormal} inline>Content</Typography>

									{!_.isEmpty(selectedContent) && (
										<Typography variant="body1" color="primary" inline
											className={`${classes.cursorPointer} ${classes.ml1x}`}
											onClick={this.handleAddContentDialogOpen.bind(this)}
										>
											Add More Content
										</Typography>
									)}
								</Grid>

								{_.isEmpty(selectedContent) && (
									<Grid item xs={12} className={classes.mb1x}>
										<Button variant="contained" color="primary"
											className={classes.buttonOval}
											onClick={this.handleAddContentDialogOpen.bind(this)}
										>
											Choose from Library
										</Button>
									</Grid>
								)}
								{!selectAll && !_.isEmpty(selectedContent) && (
									<Grid item xs={12} className={classes.mb1x}>
										{renderContent()}
									</Grid>
								)}
								{selectAll && (
										<Grid item xs={12} className={classes.mb1x}> 
											<Typography variant="body1" color="textSecondary">
												{`${totalCount} Selected`}
											</Typography>
										</Grid>
								)}
							</Grid>
						</CardContent>
					</Card>
				</MyPATDialog>

				<MyPATDialog
					dialogOpen={addContentDialogOpen}
					otherDialogProps={{ fullScreen: true }}
					customDialogTitle={
						<>
							<Grid container justify="space-between" alignItems="center">
								<Grid item xs="auto">
									<Typography
										color="textPrimary"
										variant="body1"
										className={classes.cursorPointer}
										onClick={this.handleAddContentDialogClose.bind(this)}
									>
										<BackIcon classes={{ root: classes.backIconRoot }} />
										Back to Mini Library Creation
									</Typography>
								</Grid>
								<Grid item xs />
								<Grid item xs="auto">
									<Typography variant="caption" inline>
										{totalCount} Selected
                  </Typography>
									<Button
										variant="contained"
										color="primary"
										className={classes.ml1x}
										onClick={this.handleAddContentClick.bind(this)}
									>
										Add Content
                  </Button>
								</Grid>
							</Grid>
						</>
					}
				>
					<WithContent
						isInPopUp={true}
						selectedQuestions={tempSelectedContent}
						onContentSelect={this.handleContentSelect.bind(this)}
						handleSelectAll = {this.handleSelectAll}
						fromMiniLibrary = {true}
					/>
				</MyPATDialog>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	miniLibrary: _.get(state, 'userManagement.miniLibrary', {}),
	contentTypes: _.get(state, 'mylibraryData.contentType.list', []),
	contentSubtypes: _.get(state, 'mylibraryData.contentSubtype.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	miniLibraryList,
	getMiniLibraryCount,
	showMsg
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(AddMiniLibraryDialog));